var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"each-stop-a",attrs:{"to":{
    name: 'routeinfo',
    query: {
      routedir: _vm.stopItem.routedir,
      stopseq: _vm.stopItem.stopseq,
    },
  }},on:{"click":function($event){return _vm.prepareOpenStopMenu(_vm.stopItem)}}},[_c('div',{staticClass:"stop-index"},[_vm._v("\n    "+_vm._s(_vm.stopSeq + 1)+"\n  ")]),_c('div',{staticClass:"stop-name"},[_vm._v("\n    "+_vm._s(_vm.stopItem.stopc)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }